/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4.15 9.892C4.15 5.572 7.722 2 12.042 2s7.892 3.572 7.81 7.892c0 5.483-5.4 10.384-7.062 11.797-.415.415-1.08.415-1.579 0-1.661-1.413-7.06-6.397-7.06-11.797Zm7.56 4.735c1.827 0 3.157-1.412 3.157-3.157h.083v-5.4a1.1 1.1 0 0 0-1.08-1.08 1.1 1.1 0 0 0-1.08 1.08v5.317c0 .748-.415 1.246-1.08 1.246s-1.163-.415-1.163-1.246v-.083c0-.581-.415-.997-.997-.997-.582 0-.997.499-.997.997v.25c0 1.827 1.33 3.073 3.157 3.073Z"
})), "0 0 24 24", "LocationJ");